import React from 'react';
import { SectionProps, WithRefProps } from '../types';

interface StatsSectionProps extends SectionProps, WithRefProps {
  customerCount: number;
  consultingCount: number;
  experienceYears: number;
}

const StatsSection: React.FC<StatsSectionProps> = ({ 
  inView, 
  forwardedRef, 
  customerCount, 
  consultingCount, 
  experienceYears 
}) => {
  return (
    <section id="stats" className="py-8 md:py-12 bg-primary-500">
      <div ref={forwardedRef} className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-4 max-w-7xl mx-auto px-4 md:px-6 stagger-children ${inView ? 'in-view' : ''}`}>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">{customerCount}+</div>
            <div className="text-white/90 font-medium uppercase tracking-wider text-sm">beratungen</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">{consultingCount}%</div>
            <div className="text-white/90 font-medium uppercase tracking-wider text-sm">Erfolgsquote</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">{experienceYears}+</div>
            <div className="text-white/90 font-medium uppercase tracking-wider text-sm">Branchenvielfalt</div>
          </div>
      </div>
    </section>
  );
};

export default StatsSection;